import { combineReducers } from 'redux';

import state from './reducers/state';
import tags from './reducers/tags';

export default combineReducers({
  state,
  tags,
});
